import { addAuthorizationToHeaders } from "../services/CommonService"
import refreshClient, { handleErrors } from "../services/api/RefreshClient"

export async function fetchAuthorNames (value, callback) {
    let currentValue = value
    if (currentValue && currentValue.length > 2) {
        return addAuthorizationToHeaders({})
            .then(async headers => {
                if (currentValue && currentValue.length > 2) {
                    return refreshClient.get("authors?value=" + encodeURIComponent(value), {headers})
                        .then(data => data.data)
                        .then(data => handleSuccessFetchAuthorNames(data, currentValue, value, callback))
                        .catch(error => {
                            return handleErrors(error)
                                    // Handle response as usual if we got response from the retried request
                                    .then(data => data.data)
                                    .then(data => handleSuccessFetchAuthorNames(data, currentValue, value, callback))
                                    .catch(error => Promise.reject(error))
                        })
                }
            })   
    }
}

function handleSuccessFetchAuthorNames(receivedData, currentValue, value, callback) {
    if (currentValue === value) {
        // the input is still the same - user has not typed anything new
        const authors = receivedData.map((author) => ({
            value: author.id,
            text: author.firstName + ' ' + author.lastName
        }))
        return callback(authors)
    }
}

export async function getAuthorByUrl(authorUrl) {
    return refreshClient.get("authors/url?url=" + encodeURIComponent(authorUrl), {})
        .then(data => data.data)
        .catch(async error => {
            return handleErrors(error)
                    // Handle response as usual if we got response from the retried request
                    .then(data => data.data)
                    .catch(error => Promise.reject(error))
    })
}

export async function getAuthorById(authorId) {
    return addAuthorizationToHeaders({})
    .then(async headers => {
        return refreshClient.get("authors/" + authorId, {headers})
            .then(data => data.data)
            .catch(async error => {
                return handleErrors(error)
                        // Handle response as usual if we got response from the retried request
                        .then(data => data.data)
                        .catch(error => Promise.reject(error))
            })
    })
}

export async function getAuthors(page, limit, sortBy) {
    return refreshClient.get("authors/active?" + (sortBy ? "sortBy=" + encodeURIComponent(sortBy) + "&" : "") + "page=" + page + "&limit=" + limit, {})
        .then(data => data.data)
        .catch(async error => {
            return handleErrors(error)
                    // Handle response as usual if we got response from the retried request
                    .then(data => data.data)
                    .catch(error => Promise.reject(error))
    })
}
